import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Building2, BarChart3, Globe2 } from 'lucide-react';

const copy = {
  en: {
    title: 'From Clinical Tool to Scalable Veterinary AI Platform',
    blocks: [
      { Icon: Building2, title: 'B2B SaaS for Veterinary Clinics', desc: 'Subscription-based AI tools. Workflow automation. Medical documentation infrastructure built for the real clinical day.' },
      { Icon: BarChart3, title: 'Data-Driven Clinical Intelligence', desc: 'Anonymised aggregated insights. Protocol optimisation. Decision-support that improves as more clinics join the network.' },
      { Icon: Globe2, title: 'Global Expansion Model', desc: 'Messenger-first (Telegram, WhatsApp, Signal, etc.) — no new software for clinics. Low training barrier. Scalable across languages and healthcare systems.' },
    ],
  },
  uk: {
    title: 'Від клінічного інструменту до масштабованої AI-платформи',
    blocks: [
      { Icon: Building2, title: 'B2B SaaS для ветеринарних клінік', desc: 'AI-інструменти за підпискою. Автоматизація робочих процесів. Інфраструктура медичної документації, створена для реального клінічного дня.' },
      { Icon: BarChart3, title: 'Клінічний інтелект на основі даних', desc: 'Анонімізовані агреговані інсайти. Оптимізація протоколів. Підтримка рішень, що покращується з приєднанням нових клінік до мережі.' },
      { Icon: Globe2, title: 'Модель глобального масштабування', desc: 'Messenger-first (Telegram, WhatsApp, Signal тощо) — без нового ПЗ для клінік. Низький бар’єр навчання. Масштабованість через мови та системи охорони здоров’я.' },
    ],
  },
  ja: {
    title: '臨床ツールから拡張可能な獣医AIプラットフォームへ',
    blocks: [
      { Icon: Building2, title: '獣医クリニック向けB2B SaaS', desc: 'サブスク型AIツール。ワークフロー自動化。実臨床のための医療文書インフラ。' },
      { Icon: BarChart3, title: 'データドリブン臨床インテリジェンス', desc: '匿名化された集約インサイト。プロトコル最適化。ネットワークへのクリニック参加が増えるにつれて改善する意思決定支援。' },
      { Icon: Globe2, title: 'グローバル拡張モデル', desc: 'メッセンジャーファースト（Telegram、WhatsApp、Signalなど） — クリニック向け新規ソフト不要。低い教育障壁。多言語・医療制度に対応。' },
    ],
  },
};

export default function PlatformSection() {
  const { lang } = useLanguage();
  const c = copy[lang];

  return (
    <section className="section-padding">
      <div className="container-max max-w-6xl">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-foreground text-center mb-10"
        >
          {c.title}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {c.blocks.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="card-elevated p-6"
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <b.Icon size={20} className="text-primary" />
              </div>
              <h3 className="text-base font-bold text-foreground mb-2">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
